import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {MatFabButton} from '@angular/material/button';
import {MatIcon} from '@angular/material/icon';
import {NgTemplateOutlet} from '@angular/common';
import {ROUTE_NAME_CAPABLE_BUTTON_COMPONENT} from '@aviary/injection-tokens/aviary-only.tokens';
import {BaseNamedRouterLinkDirective} from '@aviary/directives/base-named-router-link.directive';
import {MatTooltip} from '@angular/material/tooltip';
import {RoundButtonComponent} from '@aviary/buttons/base/round-button/round-button.component';

@Component({
  selector: 'mx-fab',
  templateUrl: './fab.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {provide: ROUTE_NAME_CAPABLE_BUTTON_COMPONENT, useExisting: FabComponent}
  ],
  imports: [MatFabButton, MatIcon, NgTemplateOutlet, BaseNamedRouterLinkDirective, MatTooltip]
})
export class FabComponent extends RoundButtonComponent {
  // See BaseButtonComponent and RoundButtonComponent for the rest of the available inputs.
  @Input() public color: string = this.config.defaultColors.fab;
}
